import React from "react";
import { Table, Typography, Empty } from "antd";
import { EyeFilled } from "@ant-design/icons";
import moment from "moment";

const { Text } = Typography;

const SaleRegisterTable = (props) => {
  const { dataSource, onView } = props;

  const columns = [
    {
      title: <Text strong>Sale ID</Text>,
      dataIndex: "saleId",
      key: "saleId",
      render: (text) => text || "-",
    },
    {
      title: <Text strong>Chassis Number</Text>,
      dataIndex: "chassisNumber",
      key: "chassisNumber",
      render: (text) => text || "-",
    },
    {
      title: <Text strong>Booking ID</Text>,
      dataIndex: "bookingId",
      key: "bookingId",
      render: (text) => text || "-",
    },
    {
      title: <Text strong>Sale Date</Text>,
      dataIndex: "createdAt",
      key: "createdAt",
      render: (text) => (text ? moment(text).format("DD/MM/YYYY") : "-"),
    },
    {
      title: <Text strong>Action</Text>,
      dataIndex: "id",
      align: "center",
      key: "action",
      render: (id, record) => (
        <EyeFilled
          style={{ cursor: "pointer", fontSize: "16px" }}
          onClick={() => onView(record)}
        />
      ),
    },
  ];

  return (
    <Table
      locale={{
        emptyText: (
          <Empty
            imageStyle={{ height: 25 }}
            description={<Text disabled strong>No Sale Registers Found</Text>}
          />
        ),
      }}
      rowKey={(record) => record.id}
      pagination={false}
      size="small"
      columns={columns}
      dataSource={dataSource}
      scroll={{ y: 150 }}
    />
  );
};

export default SaleRegisterTable;
